/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 * apmUrl: 埋点地址
 */
let baseUrl = ''
let routerMode = 'history'
let baseImgPath = 'http://images.cangdu.org/'
let openId = 'ohSeq0TOhWRxYG3wCb8LkkFwzEvA'
let env = ''
let ampUrl = ''

switch (process.env.NODE_ENV) {
  case 'dev':
// dev: 10.208.38.27:8080
// sit: 10.208.39.43:8080
    baseUrl = 'http://cpmapi-uat.crbeverage.com/'
    openId = window.localStorage.getItem('openId')
    env = 'dev'
    ampUrl = 'http://apm-server.crbr.com'
    break
  case 'sit':
    // baseUrl = 'http://10.0.182.211:8080/'
    baseUrl = 'http://wxapp-dev.crbeverage.com/sit/'
    openId = window.localStorage.getItem('openId')
    env = 'sit'
    ampUrl = 'http://cpmapi-uat.crbeverage.com/apm-server'
    break
  case 'prod':
    // baseUrl = 'http://cpmapi.crbeverage.com/cpm-api-getway/'
    baseUrl = 'http://cpmapi.crbeverage.com/'
    openId = window.localStorage.getItem('openId')
    env = 'prod'
    ampUrl = 'http://cpmapi-uat.crbeverage.com/apm-server'
    break
  case 'uat':
    // baseUrl = 'http://cpmapi-uat.crbeverage.com/cpm-api-getway/'
    baseUrl = 'http://cpmapi-uat.crbeverage.com/'
    // baseUrl = 'http://wxapp-dev.crbeverage.com/'
    openId = window.localStorage.getItem('openId')
    env = 'uat'
    ampUrl = 'http://cpmapi-uat.crbeverage.com/apm-server'
    break
  default:
    baseUrl = 'http://cpmapi-uat.crbeverage.com/'
    ampUrl = 'http://cpmapi-uat.crbeverage.com/apm-server'
    // baseUrl = 'http://10.208.61.17:8080/'
    // baseUrl = 'http://wxapp-dev.crbeverage.com/'
    // baseUrl = 'http://10.208.39.59:8111/mockjs/7/'
    // openId = 'oLS8Sw7Q6uohBoLn4Nx6-K27C81s'
    // baseUrl = 'http://cpmapi.crbeverage.com/'
    // oLS8SwzU4alHtRVf0mrDb_2pJ1NY
    // window.localStorage.setItem('openId', 'oFqOL1gkTYQiyC32FD37jEZOUw-E')
    // window.localStorage.setItem('openId', 'oFqOL1n7_7PlhEQUMHdhE4szKyc0')
    window.localStorage.setItem('openId', 'oNfIowSQJ7663xstL4Jq5Pofg6h4')
    openId = window.localStorage.getItem('openId')
    env = ''
    break
}

const setBaseUrl = (url) => {
  baseUrl = url + '/'
}

const setAmpUrl = (url) => {
  ampUrl = url
}

export {
  baseUrl,
  routerMode,
  baseImgPath,
  openId,
  env,
  ampUrl,
  setBaseUrl,
  setAmpUrl
}



// WEBPACK FOOTER //
// ./src/config/env.js